import Box from '@/components/UI/box/Box';
import Drawer from '@/components/UI/drawer/Drawer';
import { FC, ReactNode } from 'react';
import Styles from './ShowMorePopUp.module.scss';
import useDevice from '@/hooks/useDevice';
import Modal from '@/components/UI/modal/Modal';
import Typography from '@/components/UI/typography/Typography';
import IconButton from '@/components/UI/iconButton/IconButton';
import Button from '@/components/UI/button/Button';
import useDrawer from '@/hooks/useDrawer';
import Divider from '@/components/UI/divider/Divider';
type Props = {
  children: ReactNode;
  title: string;
  btnText?: string;
  maxWidth?: string;
};
const translateTitle = {
  distances: 'فاصله تا مکان های خاص',
  services: 'خدمات اقامتگاه',
  features: 'امکانات اقامتگاه',
  about: 'درباره اقامتگاه',
  moreRules: 'سایر قوانین'
};
const ShowMorePopUp: FC<Props> = ({
  children,
  title,
  btnText,
  maxWidth
}) => {
  const {
    isMobile
  } = useDevice();
  const {
    drawerOpen,
    drawerClose,
    isDrawerOpen
  } = useDrawer();
  return <Box data-sentry-element="Box" data-sentry-component="ShowMorePopUp" data-sentry-source-file="ShowMorePopUp.tsx">
      <Box className={Styles['more']} data-sentry-element="Box" data-sentry-source-file="ShowMorePopUp.tsx">
        <Button size="small" format="text" endIcon="arrow-left-1" onClick={() => drawerOpen(title)} data-sentry-element="Button" data-sentry-source-file="ShowMorePopUp.tsx">
          {btnText ?? 'نمایش بیشتر'}
        </Button>
      </Box>
      {isMobile ? <Drawer open={isDrawerOpen(title)} onClose={drawerClose} fullHeight maxWidth={maxWidth}>
          <Box className={Styles['inner-content']}>
            <Box className={Styles['header']}>
              <IconButton format="text" icon="close" onClick={drawerClose} size="large" />
              <Typography variant="title_Bold" color="neutral_800">
                {translateTitle[title]}
              </Typography>
              <Divider />
            </Box>
            <Box className={Styles['content']}>{children}</Box>
          </Box>
        </Drawer> : <Modal onClose={drawerClose} open={isDrawerOpen(title)} maxWidth={maxWidth}>
          <Box className={Styles['inner-content-modal']}>
            <Box className={Styles['header']}>
              <IconButton format="text" icon="close" onClick={drawerClose} size="large" />
              <Typography variant="title_Bold" color="neutral_800">
                {translateTitle[title]}
              </Typography>
              <Divider />
            </Box>
            <Box className={Styles['content']}>{children}</Box>
          </Box>
        </Modal>}
    </Box>;
};
export default ShowMorePopUp;